import React, { useState } from "react";
import { Badge, Button, Card, Col, Container, Form, Row, Table } from "react-bootstrap";

const modules = [
    { key: "employees", label: "Employee Directory", status: "Framework" },
    { key: "attendance", label: "Attendance", status: "Framework" },
    { key: "leave", label: "Leave Management", status: "Framework" },
    { key: "payroll", label: "Payroll Inputs", status: "Framework" },
    { key: "performance", label: "Performance", status: "Framework" },
    { key: "recruitment", label: "Recruitment", status: "Framework" },
    { key: "compliance", label: "Compliance", status: "Framework" },
];

const sampleEmployees = [
    { name: "Jane Admin", role: "Branch Manager", department: "Operations", status: "Active" },
    { name: "Peter Cashier", role: "Cashier", department: "Sales", status: "Active" },
    { name: "Mary Stock", role: "Inventory Officer", department: "Inventory", status: "On Leave" },
];

const HR = () => {
    const [activeModule, setActiveModule] = useState("employees");

    return (
        <Container fluid className="mt-4 hr-page text-start">
            <Row className="mb-3 align-items-center">
                <Col>
                    <h1 className="mb-0">Human Resources</h1>
                </Col>
                <Col xs="auto">
                    <Button variant="primary">Add Employee</Button>
                </Col>
            </Row>

            <Row className="g-3 mb-3">
                <Col md={3}>
                    <Card>
                        <Card.Body>
                            <Card.Title>Total Employees</Card.Title>
                            <h2>3</h2>
                        </Card.Body>
                    </Card>
                </Col>
                <Col md={3}>
                    <Card>
                        <Card.Body>
                            <Card.Title>On Leave</Card.Title>
                            <h2>1</h2>
                        </Card.Body>
                    </Card>
                </Col>
                <Col md={3}>
                    <Card>
                        <Card.Body>
                            <Card.Title>Open Roles</Card.Title>
                            <h2>2</h2>
                        </Card.Body>
                    </Card>
                </Col>
                <Col md={3}>
                    <Card>
                        <Card.Body>
                            <Card.Title>Pending Reviews</Card.Title>
                            <h2>4</h2>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>

            <Row className="g-3">
                <Col lg={3}>
                    <Card>
                        <Card.Body>
                            <Card.Title>HR Modules</Card.Title>
                            <div className="d-grid gap-2">
                                {modules.map((module) => (
                                    <Button
                                        key={module.key}
                                        variant={activeModule === module.key ? "dark" : "outline-dark"}
                                        className="text-start"
                                        onClick={() => setActiveModule(module.key)}
                                    >
                                        {module.label}
                                    </Button>
                                ))}
                            </div>
                        </Card.Body>
                    </Card>
                </Col>

                <Col lg={9}>
                    <Card>
                        <Card.Body>
                            <div className="d-flex justify-content-between align-items-center mb-3">
                                <Card.Title className="mb-0">
                                    {modules.find((module) => module.key === activeModule)?.label}
                                </Card.Title>
                                <Badge bg="secondary">Setup</Badge>
                            </div>

                            {activeModule === "employees" ? (
                                <>
                                    <Row className="mb-3">
                                        <Col md={4}>
                                            <Form.Control placeholder="Search employee" />
                                        </Col>
                                        <Col md={4}>
                                            <Form.Select>
                                                <option>All departments</option>
                                                <option>Operations</option>
                                                <option>Sales</option>
                                                <option>Inventory</option>
                                            </Form.Select>
                                        </Col>
                                        <Col md={4}>
                                            <Form.Select>
                                                <option>All statuses</option>
                                                <option>Active</option>
                                                <option>On Leave</option>
                                                <option>Inactive</option>
                                            </Form.Select>
                                        </Col>
                                    </Row>
                                    <Table responsive bordered hover>
                                        <thead>
                                            <tr>
                                                <th>Name</th>
                                                <th>Role</th>
                                                <th>Department</th>
                                                <th>Status</th>
                                                <th>Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {sampleEmployees.map((employee) => (
                                                <tr key={employee.name}>
                                                    <td>{employee.name}</td>
                                                    <td>{employee.role}</td>
                                                    <td>{employee.department}</td>
                                                    <td>{employee.status}</td>
                                                    <td>
                                                        <Button size="sm" variant="outline-primary">View</Button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>
                                </>
                            ) : (
                                <Row className="g-3">
                                    <Col md={6}>
                                        <Card>
                                            <Card.Body>
                                                <Card.Title>Register</Card.Title>
                                                <h3 className="mb-0">0</h3>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                    <Col md={6}>
                                        <Card>
                                            <Card.Body>
                                                <Card.Title>Approvals</Card.Title>
                                                <h3 className="mb-0">0</h3>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                    <Col md={6}>
                                        <Card>
                                            <Card.Body>
                                                <Card.Title>Reports</Card.Title>
                                                <h3 className="mb-0">0</h3>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                    <Col md={6}>
                                        <Card>
                                            <Card.Body>
                                                <Card.Title>Settings</Card.Title>
                                                <h3 className="mb-0">0</h3>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                </Row>
                            )}
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
};

export default HR;